export const BRAZE_IAM_PLACEMENT_ID_KEY = 'placement_id';

export const BRAZE_IAM_JSON_KEY = 'json';

export const BRAZE_IAM_PLACEMENTS = {
    MAIN_SCREEN: 'main_screen_top',
    SEND_MONEY: 'send_money_screen',
    DELIVERY_OPTIONS: 'delivery_options_screen',
    PAYMENT_OPTIONS: 'payment_options_screen',
    PROFILE: 'profile_screen',
} as const;

export const BRAZE_IAM_SCREEN_EVENTS = {
    MAIN_SCREEN: 'transfer_main_screen_shown',
    SEND_MONEY: 'send_money_screen_shown',
    DELIVERY_OPTIONS: 'delivery_options_screen_shown',
    PAYMENT_OPTIONS: 'payment_options_screen_shown',
    PROFILE: 'profile_screen_shown',
} as const;

export const BRAZE_IAM_EVENT_PROPS = {
    COUNTRY_TO: 'country_to',
} as const;

export type BrazeIamPlacement = (typeof BRAZE_IAM_PLACEMENTS)[keyof typeof BRAZE_IAM_PLACEMENTS];
export type BrazeIamScreenEvent = (typeof BRAZE_IAM_SCREEN_EVENTS)[keyof typeof BRAZE_IAM_SCREEN_EVENTS];
